/**
 * ExecutorBadge – Pill-shaped badge showing the executor's role.
 * Figma: rounded pill with person icon, "Executor" label + chevron, and estate subtitle.
 */

interface ExecutorBadgeProps {
  estateName: string;
  className?: string;
}

export default function ExecutorBadge({ estateName, className = '' }: ExecutorBadgeProps) {
  return (
    <div className={`inline-flex items-center gap-2.5 bg-white-alt border border-grey-300 rounded-full pl-3 pr-4 py-2 shadow-sm ${className}`}>
      {/* Person icon — teal */}
      <svg className="w-5 h-5 text-blue-600 shrink-0" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
      </svg>
      <div className="min-w-0">
        <div className="flex items-center gap-1">
          <span className="text-sm font-semibold text-blue-900 leading-tight">Executor</span>
          <svg className="w-3.5 h-3.5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
        <p className="text-[10px] text-grey-600 leading-tight truncate">for {estateName}'s Estate</p>
      </div>
    </div>
  );
}
